
import { defineComponent, reactive, toRefs } from "vue";
import { IonPage, IonContent, IonItem, IonLabel, IonButton, IonInput, IonText, IonSpinner, IonGrid, IonRow, IonCol, isPlatform } from "@ionic/vue";
import UserRepository from "@/repositories/UserRepository";
import Exception from "@/library/Exception";
import { useRoute } from "vue-router";

export default defineComponent({
  components: {
    IonPage,
    IonContent,
    IonItem,
    IonLabel,
    IonButton,
    IonInput,
    IonText,
    IonSpinner,
    IonGrid,
    IonRow,
    IonCol,
  },

  setup() {
    const route = useRoute();

    const state = reactive({
      userid: "",
      first_name: "",
      last_name: "",
      loading: false,
      errors: {},
    });

    const campaignId = route.params.campaignId as string;
    const btnText_sm = route.query.text_sm as string;
    const btnText_md = route.query.text_md as string;
    const btnColor = route.query.color || "darkgreen";
    const tag = (route.query.tag as string) || "";

    const btnText = () => {
      if (btnText_md) {
        return isPlatform("mobile") ? btnText_sm : btnText_md;
      }
      return btnText_sm;
    };

    const multilines = (): boolean => btnText().includes("_");

    const onSubmit = async (): Promise<void> => {
      state.loading = true;
      try {
        await UserRepository.signup(campaignId, tag, {
          userid: state.userid,
          first_name: state.first_name,
          last_name: state.last_name,
        });
        window.parent.location.href = `https://www.wintick.com/users/verify/?u=${state.userid}&t=${tag}`;
        /*if (tag.toUpperCase() == "MC_HOME") {
          window.parent.location.href = "https://www.wintick.com/users/signupMCOK/home";
        } else {
          window.parent.location.href = `https://www.wintick.com/users/signupMCOK/${tag}`;
        }*/
      } catch (error) {
        const err = await Exception.handle(error);
        if (err) {
          state.errors = err;
        }
      }
      state.loading = false;
    };

    return {
      ...toRefs(state),
      onSubmit,
      btnText: btnText(),
      btnColor,
      multilines: multilines(),
    };
  },
});
